module.exports = __webpack_public_path__ + "img/logo-admin.c314c20e.png";